import React from 'react';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import { PUZZLE_CONFIG } from '../config/puzzleConfig';
import { getBackgroundPosition } from '../utils/puzzleUtils';

const slideIn = keyframes`
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const StyledPuzzlePiece = styled(motion.div)`
  position: absolute;
  width: ${props => 100 / props.size}%;
  height: ${props => 100 / props.size}%;
  background-image: url(${props => props.imageUrl});
  background-size: ${props => PUZZLE_CONFIG.dimensions[props.size].backgroundSize};
  background-position: ${props => getBackgroundPosition(props.row, props.col, props.size)};
  background-repeat: no-repeat;
  outline: ${props => props.isCorrectPosition ? '2px solid #FFFFFF' : '1px solid rgba(255, 255, 255, 0.2)'};
  outline-offset: ${props => props.isCorrectPosition ? '-2px' : '-1px'};
  cursor: pointer;
  user-select: none;
  z-index: ${props => props.isCorrectPosition ? '100' : '1'};
  
  &:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    outline-color: ${props => props.isCorrectPosition ? '#FFFFFF' : 'rgba(255, 255, 255, 0.6)'};
    z-index: ${props => props.isCorrectPosition ? '150' : '5'};
  }
  
  &:active {
    transform: scale(1.01);
  }
`;

const PuzzlePiece = ({ 
  pieceIndex, 
  size, 
  imageUrl, 
  isMoving, 
  isCorrectPosition,
  onClick,
  layoutId,
  cellIndex
}) => {
  const row = Math.floor(pieceIndex / size);
  const col = pieceIndex % size;
  
  // 현재 셀 위치 계산
  const currentRow = Math.floor(cellIndex / size);
  const currentCol = cellIndex % size;
  
  // 절대 위치 계산
  const left = (currentCol / size) * 100;
  const top = (currentRow / size) * 100;

  return (
    <StyledPuzzlePiece
      imageUrl={imageUrl}
      row={row}
      col={col}
      size={size}
      isMoving={isMoving}
      isCorrectPosition={isCorrectPosition}
      onClick={onClick}
      layoutId={layoutId}
      layout
      style={{
        left: `${left}%`,
        top: `${top}%`
      }}
      whileHover={{ 
        scale: 1.02,
        transition: { duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }
      }}
      whileTap={{ 
        scale: 1.01,
        transition: { duration: 0.2, ease: [0.25, 0.46, 0.45, 0.94] }
      }}
      animate={{
        scale: isMoving ? 1.05 : 1,
        boxShadow: isMoving ? "0 8px 25px rgba(0, 0, 0, 0.4)" : "none",
        zIndex: isMoving ? 1000 : 1
      }}
      transition={{
        layout: { 
          duration: isMoving ? 1.2 : 0.3, 
          ease: [0.25, 0.46, 0.45, 0.94]
        },
        scale: { duration: 0.2 },
        boxShadow: { duration: 0.2 },
        zIndex: { duration: 0.1 }
      }}
    />
  );
};

export default PuzzlePiece; 